var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trophy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trophy_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.125 6.125V12.1511C6.125 16.4934 9.59816 20.0926 13.9403 20.1248C14.9794 20.1327 16.0099 19.9348 16.9722 19.5426C17.9345 19.1504 18.8097 18.5716 19.5473 17.8395C20.2849 17.1075 20.8703 16.2367 21.2698 15.2774C21.6693 14.3181 21.875 13.2892 21.875 12.25V6.125C21.875 5.89294 21.7828 5.67038 21.6187 5.50628C21.4546 5.34219 21.2321 5.25 21 5.25H7C6.76794 5.25 6.54538 5.34219 6.38128 5.50628C6.21719 5.67038 6.125 5.89294 6.125 6.125Z",
    stroke: "#217BF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 24.5H17.5",
    stroke: "#217BF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14 20.125V24.5",
    stroke: "#217BF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.6797 14H22.7499C23.6781 14 24.5684 13.6313 25.2247 12.9749C25.8811 12.3185 26.2499 11.4283 26.2499 10.5V8.75C26.2499 8.51794 26.1577 8.29538 25.9936 8.13128C25.8295 7.96719 25.6069 7.875 25.3749 7.875H21.8749",
    stroke: "#217BF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.33809 14H5.23438C4.30612 14 3.41588 13.6313 2.7595 12.9749C2.10312 12.3185 1.73438 11.4283 1.73438 10.5V8.75C1.73438 8.51794 1.82656 8.29538 1.99066 8.13128C2.15475 7.96719 2.37731 7.875 2.60938 7.875H6.10938",
    stroke: "#217BF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.e3fe289ea0ade7e664b7a620f5ef2adb.svg";
export { ForwardRef as ReactComponent };